import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5" style={{ background: "var(--bg-paper)" }}>
      <div className="w-full max-w-md card-soft p-10">
        <Link to="/" className="text-sm font-semibold" style={{ color: "var(--terracotta)" }}>← Back to site</Link>
        <h1 className="mt-4 font-display text-4xl" style={{ color: "var(--primary)" }}>Admin sign in</h1>
        <p className="mt-2 text-sm" style={{ color: "var(--text-secondary)" }}>For Dietwalaa team only.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest font-semibold" style={{ color: "var(--text-secondary)" }}>Email</label>
            <Input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-semibold" style={{ color: "var(--text-secondary)" }}>Password</label>
            <Input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full h-12 disabled:opacity-60">
            {loading ? "..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
